<template>
<div component-name="intro" class="overflow-hidden">
  <div ref="tpl_inner" class="flex justify-center items-center h-full text-skin-inverted bg-skin-inverted">
    <vector-logo-brand ref="tpl_logo" class="opacity-0" />
  </div>
</div>
</template>

<script setup>
const { $scrollTopScrollSmoother } = useNuxtApp();

const props = defineProps({
  isOpen: {
    type: Boolean,
    reqired: false,
    default: false,
  },
});

const emit = defineEmits(["close"]);
const tpl_inner = templateRef("tpl_inner");
const tpl_logo = templateRef("tpl_logo");
const route = useRoute();

onMounted(() => {
  nextTick(() => {
    let tl = gsap.timeline({
      onComplete: emit,
      onCompleteParams: ["close"],
    });

    tl.fromTo(
      tpl_logo.value.$el,
      {
        scale: 2,
        opacity: 0,
      },
      {
        scale: 1,
        opacity: 1,
        duration: 0.65,
        ease: "sine.out",
      }
    );

    if (route.name !== "locale") {
      const scrollTop = $scrollTopScrollSmoother();
      const finalH = document.querySelector(
        '[component-name="app-header"]'
      ).offsetHeight;

      tl.to(
        tpl_inner.value,
        {
          y: scrollTop === 0 ? 0 : -finalH,
          height: finalH,
          duration: 1,
          ease: "expo.inOut",
        },
        1
      );

      if (scrollTop === 0) {
        tl.to(tpl_inner.value, {
          opacity: 0,
          duration: 1,
          ease: "expo.inOut",
        });
      }
    }
  });
});
</script>